import { canonicalUrl } from '@/utils/canonical-url'

export default function ({ store, route }) {
  if (!store) {
    return
  }
  store.commit('notes/setUrlContext', canonicalUrl(route.path))
  store.commit('notes/clearNotableContext')
}
